export async function getTechnicians() {
    try {
        // Make the API call
        const response = await fetch('https://1xspcrbrk3.execute-api.ap-southeast-1.amazonaws.com/prod/getTechnicians', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            }
        });

        // Check for a successful response
        if (response.ok) {
            const data = await response.json();
            // Sort the technicians by last name alphabetically
            const sortedTechnicians = data.sort((a, b) => a.lastname.localeCompare(b.lastname));
            return sortedTechnicians;  // Return the sorted list
        } else {
            console.error(`Error: Failed to fetch technicians. Status: ${response.status}`);
            return null;
        }
    } catch (error) {
        // Catch any network or other errors
        console.error('Error: Network or other error occurred while fetching technicians.', error);
        return null;
    }
}

// Function to get a specific technician by ID
export async function getTechnician(id) {
    try {
        // Make the API call using the id
        const response = await fetch(`https://zyniirabfe.execute-api.ap-southeast-1.amazonaws.com/prod/getTechnician/${id}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            }
        });

        // Check for a successful response
        if (response.ok) {
            const data = await response.json();
            return data;  // Return the technician data (assuming it's a single object)
        } else {
            console.error(`Error: Failed to fetch technician by id. Status: ${response.status}`);
            return null;
        }
    } catch (error) {
        // Catch any network or other errors
        console.error('Error: Network or other error occurred while fetching technician by id.', error);
        return null;
    }
}

export async function getCacheTechnicians() {
  try {
    // Make the API call
    const response = await fetch(
      "https://3mdk5os5c7.execute-api.ap-southeast-1.amazonaws.com/prod/getCacheTechnicians",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    // Check for a successful response
    if (response.ok) {
      const data = await response.json();
      // Sort the cache technicians by name alphabetically
      const sortedTechnicians = data.sort((a, b) =>
        a.name.localeCompare(b.name)
      );
      return sortedTechnicians; // Return the sorted list
    } else {
      console.error(
        `Error: Failed to fetch cache technicians. Status: ${response.status}`
      );
      return null;
    }
  } catch (error) {
    // Catch any network or other errors
    console.error(
      "Error: Network or other error occurred while fetching cache technicians.",
      error
    );
    return null;
  }
}